// CreateSesionService.js
import http from "./Http";

/**
 * Crea una sesión SAE en la base de datos.
 * 
 * @param {Object} data - Objeto con los datos de la sesión SAE.
 * @returns {Promise<Object>} - Respuesta del backend con la sesión creada.
 */
const crearSesionSAE = async (data) => {
  try {
    const response = await http.post("/sesiones/crearSAE", data);
    return response.data;
  } catch (error) {
    console.error("❌ Error al registrar sesión SAE en BD:", error);
    throw error;
  }
};

const crearSesionSAC = async (data) => {
  try {
    const response = await http.post("/sesiones/crearSAC", data);
    return response.data;
  } catch (error) {
    console.error("❌ Error al registrar sesión SAC en BD:", error);
    throw error;
  }
};


const CreateSesionService= {
  crearSesionSAE,
  crearSesionSAC
};

export default CreateSesionService
